/*
	OneSwatches 2.2.0 Usage (Webpack)
	Yang @onerockwell
	Adding option availablity check

	OneSwatches 2.1.0 Usage
	Yang @onerockwell
	Adding option availablity check
	
	OneSwatches 2.0.0 Usage
	Yang @onerockwell
	
	OneSwatches 1.0.0 Usage
	Yang & Patrick @onerockwell
*/

// Import all dependencies here
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import '../../styles/modules/oneSwatch.scss';

// Define the Backbone View here (Optional)
let OneSwatchesView = Backbone.View.extend({
	
	initialize: function (settings) {
		var self = this;
		self.optionsMapMix = {};
		self.optionsFlowStr = ['','',''];
		self.$content = self.$el;
		self.$media = self.$content.find('.product-media');
		self.$mainImage = self.$media.find('#ProductMediaImages');
        self.$thumbImage = self.$media.find('#ProductMediaThumbs');
        self.$mediaSlider = self.$mainImage.find('.images-wrapper');
        self.$thumbSlider = self.$thumbImage.find('.images-wrapper');
		self.$optionSelects = self.$content.find('.single-option-selector');
		self.$optionSwatches = self.$content.find('.oneswatch:not(.oneswatch-linked) .swatches');
		
		if (settings.product) {
			self.buildOptionMaps(settings.product);
			window.optionsMapMix = self.optionsMapMix;
		}
		
		self.disableImageUpdate = typeof(settings.disableImageUpdate) !== 'undefined' ? settings.disableImageUpdate : false;

		// PreSelect
		if (settings.preSelect) {
			self.$content.find('.single-option-selector').trigger('change');
		} else {
			_.each(self.$content.find('.single-option-selector'), function(select){
				if ($(select).siblings('label').length) {
					$(select).prepend('<option value="">' + $(select).siblings('label').text() + '</option>').val('');
				} else {
					var label = 'Size'; // Hard coded single select 
					$(select).prepend('<option value="">' + label + '</option>').val('');
				}
			});
		}
		
		// Single select
		if (self.$optionSelects.length == 1) {
			self.updateOptionsInSelector();
		}

		// Product card updates on swatch click
		$(".oneswatch-linked").on("click", ".swatch-linked", function(e) {
			if ($(e.target).parents('.product-grid-item').length) {
				e.preventDefault(); 
				e.stopPropagation();

				var swatch = e.currentTarget;
			
				if (!$(swatch).hasClass('active')) {
					// Update active swatch
					self.updateActiveSwatch(swatch);
					// Update selected product for add to cart
					var newSelector = self.updateSelectedProduct(swatch);
					// Update product card details (title, images, data-handle/id, link)
					self.updateProductCard(swatch, newSelector);
				};
			}
        });
		
		// Click outside to close
		$(window).on('click', function (e) {
			$('.oneswatch').removeClass('opened');
		});
		
	},

	events: {
		'click .oneswatch' : 'swatchDropdown',
		'click .oneswatch:not(.oneswatch-linked) .swatches .swatch' : 'swatchHandle',
		'click .oneswatch-linked .swatches .swatch:not(".active")' : 'swatchHandleLink',
		'change .single-option-selector' : 'dropdownHandle'
	},
	
	swatchDropdown: function(e){
		// Dropdown control
		e.stopPropagation();
		e.preventDefault();
		var self = this,
			$curr = $(e.currentTarget);
		$curr.siblings('.oneswatch').removeClass('opened');
		$curr.toggleClass('opened');
	},
	
	swatchHandleLink: function(e){
		var self = this,
		isAjax = false,
		$curr = $(e.currentTarget),
		url = $curr.attr('href');
		
		/*
			Due to preventDefault function, we need to handle the actual link click event manually. 
			Either trigger an ajax content update request or redirect to the link url.
		*/
		
		if ($curr.data('ajax')) {
			isAjax = true;
			$('body').trigger('ajax-reload-inner',[url]);
		}
		
		if (!isAjax) {
			window.location.href = url;
		}
	},
	
	swatchHandle: function(e){
		// Swatch click control
		var self = this,
			$curr = $(e.currentTarget),
			$parent = $curr.closest('.swatches'),
			$form = $curr.closest('form'),
			$label = $parent.siblings('.swatch-label'),
			selectAttr = $parent.data('name'),
			selectIndex = $parent.data('option'),
			val = $curr.data('name'),
			size = $curr.data('size');

		if ($curr.hasClass('active')) {
			return false;
		}
		
		// Klaviyo BIS handle
		if ($form.find('.klaviyo-bis-trigger').length) {
			console.log("====================");
			console.log($curr.hasClass);
			if ($curr.hasClass('disabled')) {
				$form.find('.klaviyo-bis-trigger').css('display', 'block');
			} else {
				$form.find('.klaviyo-bis-trigger').hide();
			}
		}
			
		if ( $form.attr('id').split('-').length > 1 ) {
			// PLP
			var selectorArray = $form.attr('id').split('-'),
			pid = selectorArray[1],
			$dropdown = $form.find('#productSelect-' + pid +'-option-'+selectIndex);
		} else {
			// PDP
			var $dropdown = $('#productSelect-option-'+selectIndex);
		}
        
		$dropdown.val(val);
		$dropdown.change();

		// Update price for different variants
		var $swatchButton = e.target.closest('button');
		if ($swatchButton) {
			var $variantPrice = $swatchButton.dataset.price;
			var $variantPriceContent = $swatchButton.dataset.priceContent;
			var $priceText = $form.find('.add-to-cart-wrapper .price-box .product-price');

			$priceText.text($variantPrice);
			$priceText.attr('content', $variantPriceContent);

			

		}
		
		if (size) {
			// Variants with the fill-size metafield
			//$label.text(selectAttr + ': ' + size);
			$label.text(size);
		} else {
			//$label.text(selectAttr + ': ' + val);
			$label.text(val);
		}
	},
	
	dropdownHandle: function(e){
		var self = this;
		self.updateOptionsInSelector(e);
		self.updateSwatches(e);
	},

	updateProductCard: function(swatch, selector) {
		// Update product card image(s), title, and other attributes when a linked swatch is clicked

		// The data sent with the swatch
		var swatchData = {
			handle: swatch.getAttribute('data-product-handle'),
			id: swatch.getAttribute('data-product-id'),
			link: swatch.getAttribute('data-product-link'),
			name: swatch.getAttribute('data-product-name'),
			image: swatch.getAttribute('data-product-image'),
			imageAlt: swatch.getAttribute('data-product-alt-image'),
		};

		// The data sent with the swatch selector option (pricing & availability)
		if (selector) {
			var swatchPricing = {
				available: selector.getAttribute('data-available'),
				buttonText: selector.getAttribute('data-cart-text'),
				buttonPrice: selector.getAttribute('data-button-price'),
			};
		}

		var $productCard = $(swatch).closest('.product-grid-item');

		if ($productCard.length) {
			// The card elements we want to update
			var cardElements = {
				$name: $productCard.find('.product-name'),
				$image: $productCard.find('.product-image:not(.alt)'),
				$imageAlt: $productCard.find('.product-image.alt'),
				$link: $productCard.find('.product-link'),
				$ctaButton: $productCard.find('.add-to-cart-btn'),
				$ctaText: $productCard.find('.add-to-cart-text'),
				$ctaPrice: $productCard.find('.button-price'),
			}

			// Update product card data-attributes
			$productCard.attr({
				'data-handle': swatchData.handle,
				'data-id': swatchData.id,
			});
			
			// Update product name / title
			if (cardElements.$name.length && swatchData.name) {
				cardElements.$name.text(swatchData.name);
				console.log("xxxx"+swatchData.id);
			}

			// Update link
			if (cardElements.$link.length && swatchData.link) {
				cardElements.$link.attr('href', swatchData.link);
			}

			// Update add to cart button
			if (swatchPricing) {
				// Adjust button disable state for available vs sold out swatch
				if (cardElements.$ctaButton.length) {
					if (swatchPricing.available == "true") {
						cardElements.$ctaButton.prop('disabled', false);
						cardElements.$ctaButton.removeClass('disabled');
					} else {
						cardElements.$ctaButton.prop('disabled', true);
						cardElements.$ctaButton.addClass('disabled');
					}
				}

				// Update CTA text
				if (cardElements.$ctaText.length && swatchPricing.buttonText) {
					cardElements.$ctaText.text(swatchPricing.buttonText);
				}

				// Update price
				if (cardElements.$ctaPrice.length) {
					if (swatchPricing.buttonPrice) {
						cardElements.$ctaPrice.html(swatchPricing.buttonPrice);
					} else {
						cardElements.$ctaPrice.html('');
					}
				}
			}

			// Update images
			var updateImages = function(element, newData) {
				console.log("rrr"+element.length); 
				if (element.length && newData) {
					var $imageSource = element.find('source');
					$imageSource.each(function() {
						$(this).attr('srcset', newData);
						$(this).attr('data-srcset', newData);
					})
					var $imageSrc = element.find('img');
					$imageSrc.attr({
						'src': newData,
						'alt': swatchData.name,
					});
				}
			}
	
			updateImages(cardElements.$image, swatchData.image);
			updateImages(cardElements.$imageAlt, swatchData.imageAlt);
		}

	},

	updateActiveSwatch: function(swatch) {
		$(swatch).siblings().removeClass('active');
		$(swatch).addClass('active');
	},

	updateSelectedProduct: function(swatch) {
		var optionVal = $(swatch).data('product-id');
		var $attributeContainer = $(swatch).parents('.product-attribute-container');
		var $selector = $attributeContainer.find('.product-single__variants');

		var $activeSelector = $selector.find("[data-linked-cart]:selected");
		var $newSelector = $selector.find(`[data-linked-cart][value=${optionVal}]`);

		$activeSelector.attr("selected", null);
		$newSelector.attr("selected", "selected");
		$selector.val(optionVal);

		return $newSelector[0];
	},
	
	updateSwatches: function(e){
		var self = this,
			$curr = $(e.currentTarget),
			$form = $curr.closest('form'),
			selectedValue = $curr.val(),
			optionIndexArray = $curr.data('option').split('option'),
			optionIndex = optionIndexArray[1] - 1; // Please make sure all dropdown has a valid data-option attribute
			// console.log(optionIndexArray[1]);
		
		// Find option for out of stock selection
		if (selectedValue == null) {
			selectedValue = $curr.find("option[disabled]:selected").val();
		}

		var $swatchContainer = $form.find('.swatches[data-option="' + optionIndex + '"]');

		if ($swatchContainer.length > 0) {
			var $label = $swatchContainer.siblings('.swatch-label'),
				$selectedSwatch = $swatchContainer.find('.swatch').filter(function(index){
					return $(this).data('select') == selectedValue;
				}),
				selectAttr = $swatchContainer.data('name'),
				selectSize = $selectedSwatch.data('size');
			
			// console.log($selectedSwatch);
			$swatchContainer.find('.swatch').removeClass('active');		
			if ($selectedSwatch && !$selectedSwatch.hasClass('active')) {
				$selectedSwatch.addClass('active');
			}

			if (selectSize) {
				// Variants with the fill-size metafield
				//$label.text(selectAttr + ': ' + selectSize);
					$label.text(selectSize);
			} else {
				//$label.text(selectAttr + ': ' + selectedValue);
				$label.text(selectedValue);
			}
			
			self.updateImage(e, selectAttr);
		}
		
	},

	updateImage: function(e, attribute){
		var self = this,
			$curr = $(e.currentTarget), // Shopify select dropdown
			$form = $curr.closest('form'),
			selectedValue = $curr.val(),
			canUpdateImage = false;
		
		// Force to get the value of OOS variant for the updateImage to have option value
		if (selectedValue == null) {
			selectedValue = $curr.find("option[disabled]:selected").val();
		}

		var selectedValueHandleized = self.handleize(selectedValue);

		attribute = attribute.replace(/\-| |\_|\//g,'').toLowerCase();

		console.log(`User selection ccc kkk: [${attribute}] == [${selectedValue}][${selectedValueHandleized}]`);
		
		
		// Only apply when color got selected
		if ( attribute.indexOf("color") >= 0
			|| attribute.indexOf("Color") >= 0
			|| attribute.indexOf("shades") >= 0
			|| attribute.indexOf("Shades") >= 0
		) {
			canUpdateImage = true;
		}
		
		// P2: Please update this part for X
		if (canUpdateImage) {

            if ($form.attr('id').split('-').length > 1 && !self.isQuickshopLayout) {
                // PLP
                var $selectedSwatch = $form.find('.swatches [data-select="' + selectedValue + '"]');
                var imageSrc = $selectedSwatch.length ? $selectedSwatch.data('image') : false;
                if (imageSrc) {
                    var $cardImage = $form.parents('.item').find('.product-image:not(.alt)');

					if ($cardImage.length) {
						var $cardSource = $cardImage.find('source');
						if ($cardSource.length) {
							$cardSource.each(function() {
								$(this).attr('srcset', imageSrc);
								$(this).attr('data-srcset', imageSrc);
							});
						}
						var $imageSrc = $cardImage.find('img');
						if ($imageSrc.length) {
							$imageSrc.attr('src', imageSrc);
						}
					}
                }
            } else {
                // PDP
				// Update media images
				self.productMediaFilter(selectedValueHandleized);

				// Update thumb images if not in a slider
				// var $thumbnails = self.$thumbSlider.find('.image-thumbnail');
				// var $selectedThumbs = $thumbnails.filter(function (index) {
				// 	return ((self.handleize($(this).data('variant-option-value')) == selectedValueHandleized) || (self.handleize($(this).data('variant-option-value')) == "global"));
				// });
				// if ($selectedThumbs.length) {
				// 	self.$thumbImage.removeClass('visually-hidden');
				// }
            }
        }
	},

	productMediaFilter: function (selectedValueHandleized) {
        var self = this;
        if (selectedValueHandleized && self.$mediaSlider.hasClass('slick-initialized')) {
            self.$mediaSlider.slick('slickUnfilter');
            self.$mediaSlider.slick('slickFilter', `[data-variant-option-value = "${selectedValueHandleized}" ],[data-variant-option-value = "global" ]`);
        }
        if (selectedValueHandleized && self.$thumbSlider.hasClass('slick-initialized')) {
            self.$thumbSlider.slick('slickUnfilter');
            self.$thumbSlider.slick('slickFilter', `[data-variant-option-value = "${selectedValueHandleized}" ],[data-variant-option-value = "global" ]`);
        }
    },

	productJSONCleanup: function(product){
		// To remove the additional discounted variants that added by SCA APP
		var self = this;
		var originVariants = product.variants;
		var filteredVariants = originVariants.filter(function(value, index, arr){
			return value.title.indexOf("off)") === -1;
		});
		
		if (filteredVariants.length) {
			product.variants = filteredVariants;
		}
		return product;
	},
	
	buildOptionMaps: function(product){
		var self = this;
		
		product = self.productJSONCleanup(product);

		// Building our mapping object.
		for (var i=0; i<product.variants.length; i++) {
			var variant = product.variants[i];
			console.log("varintid:" + variant.id);
			if (variant.available) {
				
				
				// For each option
				_.each(product.options, function(option,k){
					// k is option index
					
					// Gathering values for the 1st option.
					self.optionsMapMix[k] = self.optionsMapMix[k] || [];
					
					switch (k) {
						case 0:	// Order: 0-1-2
							// Gathering values for the 2nd option.
							if (product.options.length == 1) {
								var key = variant.options[k];
								self.optionsMapMix[k] = self.optionsMapMix[k] || [];
								self.optionsMapMix[k].push(variant.options[0].toString());
							}
							if (product.options.length > 1) {
								var key = variant.options[k];
								self.optionsMapMix[k][key] = self.optionsMapMix[k][key] || [];
								self.optionsMapMix[k][key].push(variant.options[1]);
								self.optionsMapMix[k][key] = Shopify.uniq(self.optionsMapMix[k][key]);
							}
							// Gathering values for the 3rd option.
							if (product.options.length === 3) {
								var key = variant.options[k] + ' / ' + variant.options[1];
								self.optionsMapMix[k][key] = self.optionsMapMix[k][key] || [];
								self.optionsMapMix[k][key].push(variant.options[2]);
								self.optionsMapMix[k][key] = Shopify.uniq(self.optionsMapMix[k][key]);
							}
							break;
						case 1:	// Order: 1-0-2
							// Gathering values for the 2nd option.
							if (product.options.length > 1) {
								var key = variant.options[k];
								self.optionsMapMix[k][key] = self.optionsMapMix[k][key] || [];
								self.optionsMapMix[k][key].push(variant.options[0]);
								self.optionsMapMix[k][key] = Shopify.uniq(self.optionsMapMix[k][key]);
							}
							// Gathering values for the 3rd option.
							if (product.options.length === 3) {
								var key = variant.options[k] + ' / ' + variant.options[0];
								self.optionsMapMix[k][key] = self.optionsMapMix[k][key] || [];
								self.optionsMapMix[k][key].push(variant.options[2]);
								self.optionsMapMix[k][key] = Shopify.uniq(self.optionsMapMix[k][key]);
							}
							break;
						case 2:	// Order: 2-0-1
							// Gathering values for the 2nd option.
							if (product.options.length > 1) {
								var key = variant.options[k];
								self.optionsMapMix[k][key] = self.optionsMapMix[k][key] || [];
								self.optionsMapMix[k][key].push(variant.options[0]);
								self.optionsMapMix[k][key] = Shopify.uniq(self.optionsMapMix[k][key]);
							}
							// Gathering values for the 3rd option.
							if (product.options.length === 3) {
								var key = variant.options[k] + ' / ' + variant.options[0];
								self.optionsMapMix[k][key] = self.optionsMapMix[k][key] || [];
								self.optionsMapMix[k][key].push(variant.options[1]);
								self.optionsMapMix[k][key] = Shopify.uniq(self.optionsMapMix[k][key]);
							}
					}
				});
				
			}
		}
		
	},
	
	updateOptionsInSelector: function(e) {
		var self = this;
		var optionsfilter = function(options,optionsArray,value,resultsArray){
			if (options && options.length) {
				_.each(options,function(option){
					if ($.inArray(option, resultsArray) == -1) {
						resultsArray.push(option);
						var key = value + ' / ' + option;
						var newOptions = optionsArray[key];
						optionsfilter(newOptions,optionsArray,value,resultsArray);
					}
				});
			} else {
				return resultsArray;
			}
		};
		
		if ($.isEmptyObject(self.optionsMapMix)) {
			return false;
		}
		
		if (e == null) {
			console.log(`update without event.......`);
			// For single select update without passing event
			var $selector = self.$optionSelects,
				$options = $selector.find('option'),
				optionArray = self.optionsMapMix[0],
				availableOptions = [];
			
			// Update select options
			$selector.val('');
			$options.attr('disabled','disabled');
			$options = $options.filter(function(index,elem){
				return $.inArray($(elem).attr('value'), optionArray) != -1;
			});
			if ($options && $options.length) {
				$options.removeAttr('disabled');
			}
			
			// Update swatches
			var $linkedSwatch = self.$optionSwatches;
			var $swatches = $linkedSwatch.find('.swatch').addClass('disabled');
			$swatches = $swatches.filter(function(index,elem){
				var swatchValue = String($(elem).data('select'));
				var swatchValueName = String($(elem).data('name'));
				return $.inArray(swatchValue, optionArray) != -1 || $.inArray(swatchValueName, optionArray) != -1;
			});
			if ($swatches && $swatches.length) $swatches.removeClass('disabled');
			return false;
			
		} else {
			console.log(`update with event..........`);
			// For multi selects update using event trigger
			var $curr = $(e.currentTarget),
				availableOptions = [],
				selectorValue = $curr.val(),
				selectorIndex = self.$optionSelects.index($curr),
				optionArray = self.optionsMapMix[selectorIndex],
				results = optionArray[selectorValue];

			// Here we need to 'flatrize' the available options
			availableOptions.push(selectorValue);
			optionsfilter(results, optionArray, selectorValue, availableOptions);
			
			// Should the values array also check selected values? For 3 selections, we need to check the selected value agains the avaliable mitrix
			
			// self.optionsFlowStr[selectorIndex] = selectorValue;
			// console.log(self.optionsFlowStr);
			
			// _.each(self.$optionSelects, function(select){
			// 	var $selector = $(select);
			// 	var initialValue = $selector.val();
			// 	var currIndex = self.$optionSelects.index($selector);
			// 	var $options = $selector.find('option');
			// 	
			// 	if (currIndex !== selectorIndex && initialValue) {
			// 		console.log('also chose: ' + initialValue);
			// 	}
			// });
			
			 console.log('Available options: ' + availableOptions);
			
			// Update the other two select dropdowns and swatches
			_.each(self.$optionSelects, function(select){
				var $selector = $(select);
				var initialValue = $selector.val();
				var currIndex = self.$optionSelects.index($selector);
				var $options = $selector.find('option');
				
				if (currIndex !== selectorIndex) {
					// Update select options
					// console.log('Initial value: ' + initialValue);
					
					// Clean up
					if (!availableOptions.length) {
						$selector.val('');
						$options.attr('disabled','disabled');
						$options = $options.filter(function(index,elem){
							return $.inArray($(elem).attr('value'), availableOptions) != -1;
						});
						if ($options && $options.length) {
							$options.removeAttr('disabled');
						}
					}
					// Clean up done
					
					if ($.inArray(initialValue, availableOptions) !== -1) {
						$selector.val(initialValue);
					}
					
					// Update swatches
					var $linkedSwatch = self.$optionSwatches.filter(function(index,elem){
						return $(elem).data('option') == currIndex;
					});
					var $swatches = $linkedSwatch.find('.swatch').addClass('disabled').removeClass('active');
					$swatches = $swatches.filter(function(index,elem){
						var swatchValue = String($(elem).data('select'));
						return $.inArray(swatchValue, availableOptions) != -1;
					});
					if ($swatches && $swatches.length) $swatches.removeClass('disabled');
					var $selectedSwatch = $swatches.filter('[data-select="' + initialValue + '"]');
					if ($selectedSwatch && $selectedSwatch.length) $selectedSwatch.addClass('active');
				}
				
			});
			
			return false;
		}
		
	},

	handleize: function (input) {
		var self = this;
		return input.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
	},
	
	isMobile: function () {
		if ( ORW.responsive == 'small') {
			return true;
		}
		return false;
	},
	
	destroy: function() {
		var self = this;
		self.undelegateEvents();
	}

});

// Define the module here 
let OneSwatches = {
	init: function (settings) {
		return new OneSwatchesView(settings);
	}
}

// Output the module
export default OneSwatches;